
    <ng-template #rootRef>
      <div class="modal-header no-border" *ngIf="openedModalRef">
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span></button>
        <h3 class="modal-title" *ngIf="title">{{ title }}</h3>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
    </ng-template>
  